












































































































































































































































































































































import { SuggestedRateState } from "@/models";
import SuggestedRateModule from "@/store/modules/suggested-rate";
import { Component, Vue } from "vue-property-decorator";
import { namespace, State } from "vuex-class";
import CurrencyInput from "vue-currency-input";
import moment from "moment";
import ApplicationModal from "@/components/global/ApplicationModal.vue";
import { suggestedRateHeaders } from "@/helpers/suggested-rate/suggested-rate-headers";

const suggestedRate = namespace(SuggestedRateModule.name);

@Component({
  name: "FacilitySuggestedRateTable",
  components: {
    ApplicationModal
  }
})
export default class FacilitySuggestedRateTable extends Vue {
  // ===== Store ===== //
  @State("suggestedRate") private readonly suggestedRate!: SuggestedRateState;
  @suggestedRate.Action("getSuggestedRates")
  public getSuggestedRates!: () => void;

  // ===== Data ===== //
  private headers = suggestedRateHeaders;
  private selected: any = [];
  private ratesBeingConfirmed = [];
  private facilityBeingConfirmed = [];
  private confirmSelectedRatesModal = false;
  private isEdited = false;

  // ===== Methods ===== //
  private formatDate(): string {
    const start_date = moment.utc().subtract("30", "days").format("MM/DD/YYYY");
    const end_date = moment.utc().subtract("1", "days").format("MM/DD/YYYY");

    return `Data provided for ${start_date} - ${end_date}`;
  }

  private getTextColorBySign(initial_val: number, new_val: number): string {
    if (initial_val <= new_val) {
      return "green--text";
    } else {
      return "red--text";
    }
  }

  private getGPITextColor(gpi: number): string {
    if (gpi > 0) {
      return "green--text";
    } else {
      return "red--text";
    }
  }

  private formatCurrency(value: number): string {
    if (value === null || typeof value !== "number") {
      return "—";
    }
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
    return formatter.format(value);
  }

  private clearSelectedRatesFromTable(index: number): void {
    Vue.set(this.selected, index, []);
  }

  private applySelectedRatesFromTable(index: number): void {
    this.confirmSelectedRatesModal = true;
    this.ratesBeingConfirmed = this.selected[index];
  }

  private pushEditedRateChange(): void {
    this.confirmSelectedRatesModal = false;
    const rates: any = [];
    this.ratesBeingConfirmed.forEach((rate: any) => {
      rates.push({
        facility_unit_type_id: rate.facilityUnitTypeId,
        new_price: rate.suggestedPrice,
        old_price: rate.currentRate,
        suggested_price: rate.suggestedPrice
      });
    });
    this.$store
      .dispatch("suggestedRate/pushConfirmedRates", [rates, this.ratesBeingConfirmed])
      .then(() => {
        this.isEdited = false;
        this.ratesBeingConfirmed = [];
        this.selected = [];
      });
  }

  private pushRateChangesForSingleFacility(): void {
    this.confirmSelectedRatesModal = false;
    const rates: any = [];
    this.ratesBeingConfirmed.forEach((rate: any) => {
      rates.push({
        facility_unit_type_id: rate.facilityUnitTypeId,
        new_price: rate.suggestedPrice,
        old_price: rate.currentRate,
        suggested_price: rate.suggestedPrice
      });
    });
    this.$store
      .dispatch("suggestedRate/pushConfirmedRates", [rates, this.ratesBeingConfirmed])
      .then(() => {
        this.ratesBeingConfirmed = [];
        this.selected = [];
      });
  }

  private save(item: any, index: number): void {
    item.newSuggestedPrice = item.suggestedPrice;
    this.suggestedRate.filteredSuggestedRates[index].map((srate) => {
      if (srate.facilityUnitTypeId === item.facilityUnitTypeId) {
        srate.suggestedPrice = item.newSuggestedPrice;
        Vue.set(this.selected, index, [srate]);
        this.ratesBeingConfirmed = this.selected[index];
      }
    });
    this.isEdited = true;
    item.suggested_price_active = false;
  }

  private cancel(item: any, index: number): void {
    this.suggestedRate.filteredSuggestedRates[index].map((srate) => {
      if (srate.facilityUnitTypeId === item.facilityUnitTypeId) {
        srate.suggestedPrice = srate.prevSuggestedPrice;
      }
    });
    item.suggested_price_active = false;
    this.clearSelectedRatesFromTable(index);
  }

  private open(item: any, index: number): void {
    if (item.prevSuggestedPrice === 0) {
      item.prevSuggestedPrice = item.suggestedPrice;
      this.suggestedRate.filteredSuggestedRates[index].map((srate) => {
        if (srate.facilityUnitTypeId === item.facilityUnitTypeId) {
          srate.prevSuggestedPrice = srate.suggestedPrice;
        }
      });
    }
    item.suggested_price_active = true;
  }

  private mounted(): void {
    this.getSuggestedRates();
  }
}
